import React from "react";
import Contacts  from "./contacts";
class ContactsParent extends React.Component {
    render() {
        return <Contacts />;
    }
}
export default ContactsParent;
